import {
  IconBell,
  IconBook, IconHelp, IconLogout, IconWeight
} from "@tabler/icons-react"

import { NavMain } from "@/components/NavMain"
import { NavSecondary } from "@/components/NavSecondary"
import { NavUser } from "@/components/NavUser"
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar"
import { useAuth, type User } from "@/context/AuthContext"
import { useEffect, useState } from "react"
import { toast } from "sonner"

const data = {
  navMain: [
    {
      title: "Classes",
      url: "/classes",
      icon: IconWeight,
    },
    {
      title: "Bookings",
      url: "/bookings",
      icon: IconBook,
    },
  ],
  navSecondary: [
    {
      title: "Notifications",
      url: "/notifications",
      icon: IconBell,
    },
    {
      title: "Get Help",
      url: "mailto:support@penguin.fitness",
      icon: IconHelp,
    },
    {
      title: "Logout",
      url: "/logout",
      icon: IconLogout,
    }
  ]
}

export function AppSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
  const { getUser } = useAuth();
  const [user, setUser] = useState<User>();
  useEffect(() => {
    getUser().then(setUser).catch(err => {
      toast.error(err?.message ?? "Failed to fetch user details");
    });
  });
  return (
    <Sidebar collapsible="offcanvas" {...props}>
      <SidebarHeader>
        <SidebarMenu>
          <SidebarMenuItem>
            <SidebarMenuButton
              asChild
              className="data-[slot=sidebar-menu-button]:!p-1.5"
            >
              <a href="#">
                <span className="text-xl font-semibold"><span className="inline-block transform hover:scale-x-[-1]">🐧</span> Fitness</span>
              </a>
            </SidebarMenuButton>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarHeader>
      <SidebarContent>
        <NavMain items={data.navMain} />
        <NavSecondary items={data.navSecondary} className="mt-auto" />
      </SidebarContent>
      <SidebarFooter>
        <NavUser user={user} />
      </SidebarFooter>
    </Sidebar>
  )
}
